import { render, staticRenderFns } from "./assembly_work.vue?vue&type=template&id=4ca7867c&scoped=true&"
import script from "./assembly_work.vue?vue&type=script&lang=js&"
export * from "./assembly_work.vue?vue&type=script&lang=js&"
import style0 from "./assembly_work.vue?vue&type=style&index=0&id=4ca7867c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7867c",
  null
  
)

export default component.exports